import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ICONS from "../../../assets/Icons";
import CommonToast from "../../../components/_utils/CommonToast";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";

const baseUrl = env.REACT_APP_BASE_URL;

export const xpentraLogout = createAsyncThunk(
  "xpentraLogout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`${baseUrl}/users/logout`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });

      const data = response?.data;

      if (data?.status) {
        CommonToast({
          text: data?.message || "Logged out successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });
      }

      return data;
    } catch (error) {
      const err = error?.response?.data;

      if (err?.errors?.token_expired) {
        CommonToast({
          text: err.errors.token_expired[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (err?.errors?.user_unauthorized) {
        CommonToast({
          text: err.errors.user_unauthorized[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (err?.message) {
        CommonToast({
          text: err.message,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else {
        CommonToast({
          text: "Something went wrong",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return rejectWithValue(err?.errors || error.message);
    }
  },
);

const initialState = {
  xpentraLogoutLoading: null,
  xpentraLogoutData: null,
  xpentraLogoutError: null,
};

export const xpentraLogoutSlice = createSlice({
  name: "xpentraLogoutSlice",
  initialState,
  reducers: {
    xpentraLogoutSliceReset: (state) => {
      state.xpentraLogoutLoading = initialState?.xpentraLogoutLoading;
      state.xpentraLogoutData = initialState?.xpentraLogoutData;
      state.xpentraLogoutError = initialState?.xpentraLogoutError;
    },
  },
  extraReducers: (reducerResults) => {
    reducerResults.addCase(xpentraLogout.pending, (state) => {
      state.xpentraLogoutLoading = true;
    });
    reducerResults.addCase(xpentraLogout.fulfilled, (state, action) => {
      state.xpentraLogoutLoading = false;
      state.xpentraLogoutData = action?.payload;
    });
    reducerResults.addCase(xpentraLogout.rejected, (state, action) => {
      state.xpentraLogoutLoading = false;
      state.xpentraLogoutData = false;
      state.xpentraLogoutError = { isErrorStatus: true };
    });
  },
});

export const { xpentraLogoutSliceReset } = xpentraLogoutSlice.actions;

export default xpentraLogoutSlice.reducer;
